import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTable } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import {
  DocumentoTipoRequisito,
  EstadoDocumentoItem,
  EstadoSolicitud,
  EstadoSolicitudItem,
  Roles,
  SolicitudSeccion,
  eTypeResult,
} from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { ISolicitudModel } from 'src/app/models/interfaces/ISolicitudModel';
import { IFilterUsuarioModel } from 'src/app/models/interfaces/seguridad/IFilterUsuarioModel';
import { ISolicitudDerivarModel } from 'src/app/models/interfaces/solicitud/ISolicitudDerivarModel';
import { ISolicitudValidarModel } from 'src/app/models/interfaces/solicitud/ISolicitudValidarModel';
import { FilterUsuarioModel } from 'src/app/models/seguridad/FilterUsuarioModel';
import { EquipoModel } from 'src/app/models/solicitud/EquipoModel';
import { PersonalModel } from 'src/app/models/solicitud/PersonalModel';
import { SolicitudDerivarModel } from 'src/app/models/solicitud/SolicitudDerivarModel';
import { SolicitudDocumentoTecnicoModel } from 'src/app/models/solicitud/SolicitudDocumentoTecnicoModel';
import { SolicitudModel } from 'src/app/models/solicitud/SolicitudModel';
import { SolicitudValidarModel } from 'src/app/models/solicitud/SolicitudValidarModel';
import { VehiculoModel } from 'src/app/models/solicitud/VehiculoModel';
import { UsuarioResultadoBusquedaModel } from 'src/app/models/usuario/UsuarioResultadoBusquedaModel';
import { SeguridadUsuarioService } from 'src/app/services/seguridad/seguridad-usuario.service';
import { SolicitudService } from 'src/app/services/solicitud/solicitud.service';
import { SolicitudDerivarDialogComponent } from '../../dialogs/solicitud-derivar-dialog/solicitud-derivar-dialog.component';
import { ValidarEquipoDialogComponent } from '../../equipo/validar-equipo-dialog/validar-equipo-dialog.component';
import { ValidarPersonalDialogComponent } from '../../personal/validar-personal-dialog/validar-personal-dialog.component';
import { ValidarVehiculoDialogComponent } from '../../vehiculo/validar-vehiculo-dialog/validar-vehiculo-dialog.component';

import { SolicitudDocumentosTecnicosService } from 'src/app/services/solicitud-documentos-tecnicos/solicitud-documentos-tecnicos.service';

import * as fileSaver from 'file-saver';
import { ISolicitudDocumentoTecnicoModel } from 'src/app/models/interfaces/solicitud/documento-tecnico/ISolicitudDocumentoTecnicoModel';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { SolicitudDocumentoTecnicoValidarModel } from 'src/app/models/solicitud/documento/SolicitudDocumentoTecnicoValidarModel';
import { SolicitudDocumentoModel } from 'src/app/models/solicitud/documento/SolicitudDocumentoModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { AdjuntarTipoDocumentoDialogComponent, AdjuntarTipoDocumentoModel } from '../../tipo-documento/adjuntar-tipo-documento-dialog/adjuntar-tipo-documento-dialog/adjuntar-tipo-documento-dialog.component';
import { SelectionModel } from '@angular/cdk/collections';
import { ISolicitudPersonaModel } from 'src/app/models/interfaces/solicitud/ISolicitudPersonaModel';
import { ISolicitudEquipoModel } from 'src/app/models/interfaces/solicitud/ISolicitudEquipoModel';
import { ISolicitudVehiculoModel } from 'src/app/models/interfaces/solicitud/ISolicitudVehiculoModel';
import { IFilterConfiguracionDocumentoModel } from 'src/app/models/interfaces/configuracion-documento/IFilterConfiguracionDocumentoModel';
import { FilterConfiguracionDocumentoModel } from 'src/app/models/configuracion-documento/FilterConfiguracionDocumentoModel';
import { ConfiguracionDocumentoService } from 'src/app/services/configuracion-documento/configuracion-documento.service';
import { DocumentacionRequeridaModel } from 'src/app/models/solicitud/DocumentacionRequeridaModel';
import { SolicitudPersonalAsignarDocumentoModel } from 'src/app/models/solicitud/personal/SolicitudPersonalAsignarDocumentoModel';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { SolicitudPersonaService } from 'src/app/services/solicitud-persona/solicitud-persona.service';
import { SolicitudEquipoAsignarDocumentoModel } from 'src/app/models/solicitud/equipos/SolicitudEquipoAsignarDocumentoModel';
import { SolicitudEquipoService } from 'src/app/services/solicitud-equipo/solicitud-equipo.service';
import { SolicitudVehiculoService } from 'src/app/services/solicitud-vehiculo/solicitud-vehiculo.service';
import { SolicitudVehiculoAsignarDocumentoModel } from 'src/app/models/solicitud/vehiculos/SolicitudVehiculoAsignarDocumentoModel';
import { SolicitudDocumentoTecnicoAsignarModel } from 'src/app/models/solicitud/documento/SolicitudDocumentoTecnicoAsignarModel';
import { VisorPdfDialogComponent } from 'src/app/components/shared/visor-pdf-dialog/visor-pdf-dialog.component';
import { VisorPdfDocumentoModel } from 'src/app/models/common/VisorPdfDocumentoModel';

@Component({
  selector: 'app-solicitud-validar',
  templateUrl: './solicitud-validar.component.html',
  styleUrls: ['./solicitud-validar.component.css'],
})
export class SolicitudValidarComponent implements OnInit {
  public itemSolicitud: ISolicitudModel;
  public model: ISolicitudValidarModel;

  displayedColumnsPersonal: string[] = [
    'nombre',
    'nroDocumentIdentidad',
    'cargo',
    'cantidad_documentos',
    'estado',
    'acciones',
    'select',
  ];
  displayedColumnsEquipos: string[] = [
    // 'equipo',
    'marca',
    'modelo',
    'serie',
    'cantidad_documentos',
    'estado',
    'acciones',
    'select',
  ];
  displayedColumnsVehiculos: string[] = [
    'marca',
    'modelo',
    'placa',
    'color',
    'anio',
    'chofer',
    'cantidad_documentos',
    'estado',
    'acciones',
    'select',
  ];
  displayedColumnsDocumentacionTecnica: string[] = [
    'nombre',
    'idRequisito',
    'fechaVencimiento',
    'idDocumento',
    'aprobado',
    'observado',
    'acciones',
  ];

  @ViewChild('tablePersonal', { static: true, read: MatTable })
  tablePersonas!: MatTable<any>;
  @ViewChild('tableEquipos', { static: true, read: MatTable })
  tableEquipos!: MatTable<any>;
  @ViewChild('tableVehiculos', { static: true, read: MatTable })
  tableVehiculos!: MatTable<any>;

  id: number;
  listaSupervisores: UsuarioResultadoBusquedaModel[] = new Array<UsuarioResultadoBusquedaModel>();
  listaCoordinadores: UsuarioResultadoBusquedaModel[] = new Array<UsuarioResultadoBusquedaModel>();
  avanceRevisionPersonas: number;
  avanceRevisionEquipos: number;
  avanceRevisionVehiculos: number;
  avanceRevisionDocTecnica: number;
  firstLoad: boolean = true;
  expandPersonal: boolean = false;
  expandEquipos: boolean = false;
  expandVehiculos: boolean = false;
  expandDocTecnica: boolean = false;
  seccionPersonal: SolicitudSeccion = SolicitudSeccion.Personal;
  seccionEquipos: SolicitudSeccion = SolicitudSeccion.Equipos;
  seccionVehiculos: SolicitudSeccion = SolicitudSeccion.Vehiculos;
  seccionDocumentacionTecnica: SolicitudSeccion = SolicitudSeccion.DocumentacionTecnica;
  selectionPersonas = new SelectionModel<ISolicitudPersonaModel>(true, []);
  selectionEquipos = new SelectionModel<ISolicitudEquipoModel>(true, []);
  selectionVehiculos = new SelectionModel<ISolicitudVehiculoModel>(true, []);
  lista_DocumentoTecnicos: SolicitudDocumentoTecnicoModel[] = new Array<SolicitudDocumentoTecnicoModel>()
  constructor(
    private route: ActivatedRoute,
    private solicitudService: SolicitudService,
    private solicitudPersonaService: SolicitudPersonaService,
    private solicitudEquipoService: SolicitudEquipoService,
    private solicitudVehiculoService: SolicitudVehiculoService,
    private solicitudDocumentoTecnicoService: SolicitudDocumentosTecnicosService,
    private usuarioService: SeguridadUsuarioService,
    public dialog: MatDialog,
    private router: Router,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
    private configuracionDocumentoService: ConfiguracionDocumentoService,
  ) {
    this.itemSolicitud = new SolicitudModel();
    this.id = 0;
    this.model = new SolicitudValidarModel();
    this.avanceRevisionPersonas = 0;
    this.avanceRevisionEquipos = 0;
    this.avanceRevisionVehiculos = 0;
    this.avanceRevisionDocTecnica = 0;
  }

  isAllSelected() {
    const numSelected = this.selectionPersonas.selected.length;
    const numRows = this.itemSolicitud.personas.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selectionPersonas.clear() :
      this.itemSolicitud.personas.forEach(row => this.selectionPersonas.select(row));
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id = params['id']; // (+) converts string 'id' to a number
      this.model.idSolicitud = this.id;
      // In a real app: dispatch action to load the details here.
    });

    this.getSolicitud();


  }

  private getSolicitud() {
    this.solicitudService
      .getById(this.id)
      .subscribe((data: ISolicitudModel) => {
        this.itemSolicitud = data;
        if (this.itemSolicitud.idEstadoPrevioAdicion) {
          this.model.idSupervisor = this.itemSolicitud.idSupervisor;
          this.model.idCoordinador = this.itemSolicitud.idCoordinador;
        }

        this.itemSolicitud.documentosTecnicos = this.itemSolicitud.documentosTecnicos.filter(p => p.idSolicitudDocumentoTecnico > 0);
        this.itemSolicitud.logs = this.itemSolicitud.logs.filter(p => p.comentarios != "" && p.comentarios != null);
        this.itemSolicitud.logsDocumentacionTecnica = this.itemSolicitud.logsDocumentacionTecnica.filter(p => p.comentarios != "" && p.comentarios != null);

        this.itemSolicitud.comentarioPorValidacionDocumentosTecnicos = '';

        let totalDocumentos: number = 0;
        let totalDocumentosRevisados: number = 0;
        this.itemSolicitud.personas.forEach((p) => {
          p.documentosRevisados = p.documentos.filter(d => d.idEstado == EstadoDocumentoItem.APROBADO).length;
          //p.documentosRevisados = p.documentos.filter(d=>d.idEstado==EstadoDocumentoItem.APROBADO || d.idEstado==EstadoDocumentoItem.OBSERVADO).length;
          totalDocumentosRevisados += p.documentosRevisados;
          totalDocumentos += p.documentos.length;
        });
        this.avanceRevisionPersonas = totalDocumentos > 0 ? (totalDocumentosRevisados / totalDocumentos) * 100 : 0;
        this.expandPersonal = !(totalDocumentos === totalDocumentosRevisados);
        if (this.itemSolicitud.aplicaEquipos) {
          totalDocumentosRevisados = 0;
          totalDocumentos = 0;
          this.itemSolicitud.equipos.forEach((p) => {
            p.documentosRevisados = p.documentos.filter(d => d.idEstado == EstadoDocumentoItem.APROBADO).length;
            totalDocumentosRevisados += p.documentosRevisados;
            totalDocumentos += p.documentos.length;
          });
          this.avanceRevisionEquipos = totalDocumentos > 0 ? (totalDocumentosRevisados / totalDocumentos) * 100 : 0;
          this.expandEquipos = !(totalDocumentos === totalDocumentosRevisados);
        }
        if (this.itemSolicitud.aplicaVehiculos) {
          totalDocumentosRevisados = 0;
          totalDocumentos = 0;
          this.itemSolicitud.vehiculos.forEach((p) => {
            p.documentosRevisados = p.documentos.filter(d => d.idEstado == EstadoDocumentoItem.APROBADO).length;
            totalDocumentosRevisados += p.documentosRevisados;
            totalDocumentos += p.documentos.length;
          });
          this.avanceRevisionVehiculos = totalDocumentos > 0 ? (totalDocumentosRevisados / totalDocumentos) * 100 : 0;
          this.expandVehiculos = !(totalDocumentos === totalDocumentosRevisados);
        }
        if (this.itemSolicitud.aplicaDocumentacionTecnica) {
          totalDocumentosRevisados = this.itemSolicitud.documentosTecnicos.filter(d => d.idEstado == EstadoDocumentoItem.APROBADO).length;
          totalDocumentos = this.itemSolicitud.documentosTecnicos.length;
          this.itemSolicitud.documentosTecnicos.forEach((p) => {
            p.aprobado = p.idEstado === EstadoDocumentoItem.APROBADO;
            p.observado = p.idEstado === EstadoDocumentoItem.OBSERVADO;
          });
          this.avanceRevisionDocTecnica = totalDocumentos > 0 ? (totalDocumentosRevisados / totalDocumentos) * 100 : 0;
          this.expandDocTecnica = !(totalDocumentos === totalDocumentosRevisados);
        }
        this.selectionPersonas = new SelectionModel<ISolicitudPersonaModel>(true, []);
        this.selectionEquipos = new SelectionModel<ISolicitudEquipoModel>(true, []);
        this.selectionVehiculos = new SelectionModel<ISolicitudVehiculoModel>(true, []);
        if (this.firstLoad) {
          this.firstLoad = false;
          let filterUsuario: IFilterUsuarioModel = new FilterUsuarioModel();
          filterUsuario.idRol = Roles.SUPERVISOR;
          filterUsuario.idSede = this.itemSolicitud.idSede;

          this.usuarioService
            .getList(filterUsuario)
            .subscribe(
              (data: SearchResultModel<UsuarioResultadoBusquedaModel[]>) => {
                this.listaSupervisores = data.items;
              }
            );

          let filterCoordinadores: IFilterUsuarioModel = new FilterUsuarioModel();
          filterCoordinadores.idRol = Roles.COORDINADOR_SSO;
          filterCoordinadores.idSede = this.itemSolicitud.idSede;

          this.usuarioService
            .getList(filterCoordinadores)
            .subscribe(
              (data: SearchResultModel<UsuarioResultadoBusquedaModel[]>) => {
                this.listaCoordinadores = data.items;
              }
            );
        }
        this.getConfiguracionDocumentosPorTipoVisita();
      });
  }

  openDialogPersonal(personal: PersonalModel): void {
    personal.idSolicitud = this.itemSolicitud.idSolicitud;
    personal.codigoSolicitud = this.itemSolicitud.codigo;

    const dialogRef = this.dialog.open(ValidarPersonalDialogComponent, {
      width: '1000px',
      // data: { name: this.name, animal: this.animal}
      data: personal,
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      console.log(result);
      if (result)
        this.getSolicitud();
      // this.solicitudService
      //   .getById(this.id)
      //   .subscribe((data: ISolicitudModel) => {
      //     this.itemSolicitud = data;
      //     this.itemSolicitud.documentosTecnicos= this.itemSolicitud.documentosTecnicos.filter(p => p.idSolicitudDocumentoTecnico > 0);
      //     this.tablePersonas.renderRows();
      //   });
    });
  }

  openDialogEquipo(equipo: EquipoModel): void {
    equipo.idSolicitud = this.itemSolicitud.idSolicitud;
    equipo.codigoSolicitud = this.itemSolicitud.codigo;

    const dialogRef = this.dialog.open(ValidarEquipoDialogComponent, {
      width: '1000px',
      // data: { name: this.name, animal: this.animal}
      data: equipo,
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result)
        this.getSolicitud();
      // this.solicitudService
      //   .getById(this.id)
      //   .subscribe((data: ISolicitudModel) => {
      //     this.itemSolicitud = data;
      //     this.tableEquipos.renderRows();
      //   });
    });
  }

  openDialogVehiculo(vehiculo: VehiculoModel): void {
    vehiculo.idSolicitud = this.itemSolicitud.idSolicitud;
    vehiculo.codigoSolicitud = this.itemSolicitud.codigo;
    const dialogRef = this.dialog.open(ValidarVehiculoDialogComponent, {
      width: '1000px',
      // data: { name: this.name, animal: this.animal}
      data: vehiculo,
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result)
        this.getSolicitud();
    });
  }
  getDataCabecera() {
    //datos para la cabecera

    this.model.fechaInicio = this.itemSolicitud.fechaInicio;
    this.model.fechaFin = this.itemSolicitud.fechaFin;
    this.model.ordenCompra = this.itemSolicitud.ordenCompra;
    this.model.notificarA = this.itemSolicitud.notificarA;
    this.model.trabajo = this.itemSolicitud.trabajo;
    this.model.motivo = this.itemSolicitud.motivo;
    this.model.subContratista = this.itemSolicitud.subContratista;
  }
  aprobar(): void {
    this.getDataCabecera();
    this.confirmDialogService.open('¿Está seguro de aprobar la solicitud?'); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        // GUARDAR DOCUMENTACION TECNICA
        let documentosTecnicosModel = new SolicitudDocumentoTecnicoValidarModel();
        documentosTecnicosModel.idSolicitud = this.itemSolicitud.idSolicitud;
        documentosTecnicosModel.comentarios = this.itemSolicitud.comentarioPorValidacionDocumentosTecnicos;

        this.itemSolicitud.documentosTecnicos.forEach(p => {
          let documento = new SolicitudDocumentoModel();
          documento.idDocumento = p.idSolicitudDocumentoTecnico;
          if (p.aprobado) {
            documento.idEstado = EstadoDocumentoItem.APROBADO;
          }
          else if (p.observado) {
            documento.idEstado = EstadoDocumentoItem.OBSERVADO;
          }
          else {
            documento.idEstado = EstadoDocumentoItem.PENDIENTE;
          }

          documentosTecnicosModel.documentos.push(documento);
        });

        this.solicitudDocumentoTecnicoService.validar(documentosTecnicosModel).subscribe((data) => {
          // ENVIAR SOLICITUD
          if (this.itemSolicitud.aplicaPersonas)
            this.model.idEstado = EstadoSolicitud.PROGRAMACION_INDUCCION;
          else
            this.model.idEstado = EstadoSolicitud.FINALIZADO;
          this.solicitudService.aprobar(this.model).subscribe((result: ActionResultModel) => {
            if (result.type != eTypeResult.SUCCESS) {
              this.alertDialogService.open(result.message);
            }
            else {
              if (this.itemSolicitud.aplicaPersonas && this.itemSolicitud.idEstadoPrevioAdicion == null)
                this.alertDialogService.open('La solicitud fue APROBADA y enviada al responsable de inducción.');
              else
                this.alertDialogService.open('La solicitud fue APROBADA.');
            }
            this.router.navigate(['/solicitudes-engie']);
          });
        });
      }
    });
  }

  rechazar(): void {
    this.getDataCabecera();
    if (
      this.model.comentarioPorValidacion == '' ||
      !this.model.comentarioPorValidacion
    ) {
      this.alertDialogService.open('Debe ingresar un comentario');
    } else {
      this.confirmDialogService.open('¿Esta seguro de observar toda la solicitud?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          if (this.itemSolicitud.aplicaDocumentacionTecnica && this.itemSolicitud.idEstadoDocumentacionTecnica == EstadoSolicitudItem.PENDIENTE) {
            // GUARDAR DOCUMENTACION TECNICA
            let documentosTecnicosModel = new SolicitudDocumentoTecnicoValidarModel();
            documentosTecnicosModel.idSolicitud = this.itemSolicitud.idSolicitud;
            documentosTecnicosModel.comentarios = this.itemSolicitud.comentarioPorValidacionDocumentosTecnicos;

            this.itemSolicitud.documentosTecnicos.forEach(p => {
              let documento = new SolicitudDocumentoModel();
              documento.idDocumento = p.idSolicitudDocumentoTecnico;
              if (p.aprobado) {
                documento.idEstado = EstadoDocumentoItem.APROBADO;
              }
              else if (p.observado) {
                documento.idEstado = EstadoDocumentoItem.OBSERVADO;
              }
              else {
                documento.idEstado = EstadoDocumentoItem.PENDIENTE;
              }

              documentosTecnicosModel.documentos.push(documento);


            });
            this.solicitudDocumentoTecnicoService.validar(documentosTecnicosModel).subscribe((data) => {
              // ENVIAR SOLICITUD
              this.model.idEstado = EstadoSolicitud.OBSERVADO;
              this.solicitudService.validar(this.model).subscribe((p) => {
                this.alertDialogService.open('La solicitud fue observada y se notificó al contratista para su correción.');
                this.router.navigate(['/solicitudes-engie']);
              });
            });
          }
          else {
            // ENVIAR SOLICITUD
            this.model.idEstado = EstadoSolicitud.OBSERVADO;
            this.solicitudService.validar(this.model).subscribe((p) => {
              this.alertDialogService.open('La solicitud fue observada y se notificó al contratista para su correción.');
              this.router.navigate(['/solicitudes-engie']);
            });
          }
        }
      });
    }
  }

  derivar(): void {
    let derivarModel: ISolicitudDerivarModel = new SolicitudDerivarModel();
    derivarModel.idSede = this.itemSolicitud.idSede;
    derivarModel.idSolicitud = this.itemSolicitud.idSolicitud;

    const dialogRef = this.dialog.open(SolicitudDerivarDialogComponent, {
      width: '500px',
      // data: { name: this.name, animal: this.animal}
      data: derivarModel,
    });

    dialogRef.afterClosed().subscribe((result) => {
      // this.solicitudService
      // .getById(this.id)
      // .subscribe((data: ISolicitudModel) => {
      //   this.itemSolicitud = data;
      //   this.tableVehiculos.renderRows();
      // });
    });
  }

  devolver(): void { }

  changeAprobado(element: SolicitudDocumentoTecnicoModel) {
    if (element.aprobado) {
      element.observado = false;
      element.idEstado = EstadoSolicitudItem.APROBADO;
    } else if (element.observado) {
      element.idEstado = EstadoSolicitudItem.OBSERVADO;
    } else {
      element.idEstado = EstadoSolicitudItem.PENDIENTE;
    }
  }

  changeObservado(element: SolicitudDocumentoTecnicoModel) {
    if (element.observado) {
      element.aprobado = false;
      element.idEstado = EstadoSolicitudItem.OBSERVADO;
      this.model.idSupervisor = '';
    } else if (element.aprobado) {
      element.idEstado = EstadoSolicitudItem.APROBADO;
    } else {
      element.idEstado = EstadoSolicitudItem.PENDIENTE;
    }
  }

  EsValido(): boolean {
    // console.log('personas' +this.itemSolicitud.personas.filter(p => p.idEstado === EstadoSolicitudItem.OBSERVADO || p.idEstado === EstadoSolicitudItem.PENDIENTE).length);
    // console.log('equipos' +this.itemSolicitud.equipos.filter(p => p.idEstado === EstadoSolicitudItem.OBSERVADO || p.idEstado === EstadoSolicitudItem.PENDIENTE).length);
    // console.log('vehiculos' +this.itemSolicitud.vehiculos.filter(p => p.idEstado === EstadoSolicitudItem.OBSERVADO || p.idEstado === EstadoSolicitudItem.PENDIENTE).length);
    // console.log('Documentos tecnicos' + this.itemSolicitud.documentosTecnicos.filter(p => p.idEstado === EstadoSolicitudItem.OBSERVADO || p.idEstado === EstadoSolicitudItem.PENDIENTE).length);
    return (
      this.itemSolicitud.personas.filter(
        (p) =>
          p.idEstado === EstadoSolicitudItem.OBSERVADO ||
          p.idEstado === EstadoSolicitudItem.PENDIENTE
      ).length === 0 &&
      this.itemSolicitud.equipos.filter(
        (p) =>
          p.idEstado === EstadoSolicitudItem.OBSERVADO ||
          p.idEstado === EstadoSolicitudItem.PENDIENTE
      ).length === 0 &&
      this.itemSolicitud.vehiculos.filter(
        (p) =>
          p.idEstado === EstadoSolicitudItem.OBSERVADO ||
          p.idEstado === EstadoSolicitudItem.PENDIENTE
      ).length === 0 &&
      (
        (this.itemSolicitud.aplicaDocumentacionTecnica &&
          this.itemSolicitud.documentosTecnicos.filter(
            (p) =>
              (p.idEstado === EstadoSolicitudItem.OBSERVADO ||
                p.idEstado === EstadoSolicitudItem.PENDIENTE) && p.nombreArchivo !== ''
          ).length === 0) || !this.itemSolicitud.aplicaDocumentacionTecnica
      )
    );
  }

  EsValidoParaEnviar(): boolean {
    // console.log('personas' +this.itemSolicitud.personas.filter(p => p.idEstado === EstadoSolicitudItem.OBSERVADO || p.idEstado === EstadoSolicitudItem.PENDIENTE).length);
    // console.log('equipos' +this.itemSolicitud.equipos.filter(p => p.idEstado === EstadoSolicitudItem.OBSERVADO || p.idEstado === EstadoSolicitudItem.PENDIENTE).length);
    // console.log('vehiculos' +this.itemSolicitud.vehiculos.filter(p => p.idEstado === EstadoSolicitudItem.OBSERVADO || p.idEstado === EstadoSolicitudItem.PENDIENTE).length);
    // console.log('Documentos tecnicos' + this.itemSolicitud.documentosTecnicos.filter(p => p.idEstado === EstadoSolicitudItem.OBSERVADO || p.idEstado === EstadoSolicitudItem.PENDIENTE).length);

    return (
      this.itemSolicitud.personas.filter(
        (p) =>
          p.idEstado === EstadoSolicitudItem.OBSERVADO ||
          p.idEstado === EstadoSolicitudItem.PENDIENTE
      ).length === 0 &&
      this.itemSolicitud.equipos.filter(
        (p) =>
          p.idEstado === EstadoSolicitudItem.OBSERVADO ||
          p.idEstado === EstadoSolicitudItem.PENDIENTE
      ).length === 0 &&
      this.itemSolicitud.vehiculos.filter(
        (p) =>
          p.idEstado === EstadoSolicitudItem.OBSERVADO ||
          p.idEstado === EstadoSolicitudItem.PENDIENTE
      ).length === 0 &&
      (
        (this.itemSolicitud.aplicaDocumentacionTecnica &&
          this.itemSolicitud.documentosTecnicos.filter(
            (p) =>
              (p.idEstado === EstadoSolicitudItem.OBSERVADO ||
                p.idEstado === EstadoSolicitudItem.PENDIENTE) && p.nombreArchivo !== ''
          ).length === 0) || !this.itemSolicitud.aplicaDocumentacionTecnica
      ) &&
      ((this.model.idSupervisor !== '' &&
        this.model.idCoordinador !== '') || !this.itemSolicitud.aplicaPersonas)
    );
  }

  downloadDocumentFromService(element: ISolicitudDocumentoTecnicoModel) {
    if (element.permiteVisor) {
      let modelVisor: VisorPdfDocumentoModel = new VisorPdfDocumentoModel();
      modelVisor.seccion = SolicitudSeccion.DocumentacionTecnica;
      modelVisor.idSolicitudDocumento = element.idSolicitudDocumentoTecnico;
      modelVisor.codigoSolicitud = this.itemSolicitud.codigo;
      modelVisor.nombreArchivo = element.nombreArchivo;
      const dialogVisroRef = this.dialog.open(VisorPdfDialogComponent, {
        width: '1300px',
        data: modelVisor,
        autoFocus: false,
      });
    }
    else {
      this.solicitudDocumentoTecnicoService.downloadDocumento(
        this.itemSolicitud.codigo,
        element.idSolicitudDocumentoTecnico
      ).subscribe(data => {
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        fileSaver.saveAs(blob, element.nombreArchivo);
      });
    }
  }

  guardarDocumentosTecnicos() {
    let pendientes = this.itemSolicitud.documentosTecnicos.filter(
      (p) => !p.aprobado && !p.observado
    ).length;

    let pendientesObservados = this.itemSolicitud.documentosTecnicos.filter(
      (p) => p.observado
    ).length;

    if (
      pendientes == 0 &&
      pendientesObservados >= 1 &&
      (this.itemSolicitud.comentarioPorValidacionDocumentosTecnicos == '' || !this.itemSolicitud.comentarioPorValidacionDocumentosTecnicos)
    ) {
      this.alertDialogService.open('Debe ingresar un comentario');
    } else {
      let pendientes = this.itemSolicitud.documentosTecnicos.filter(
        (p) => !p.aprobado && !p.observado
      ).length;

      let documentosTecnicosModel = new SolicitudDocumentoTecnicoValidarModel();
      documentosTecnicosModel.idSolicitud = this.itemSolicitud.idSolicitud;
      documentosTecnicosModel.comentarios = this.itemSolicitud.comentarioPorValidacionDocumentosTecnicos;

      this.itemSolicitud.documentosTecnicos.forEach(p => {
        let documento = new SolicitudDocumentoModel();
        documento.idDocumento = p.idSolicitudDocumentoTecnico;
        if (p.aprobado) {
          documento.idEstado = EstadoDocumentoItem.APROBADO;
        }
        else if (p.observado) {
          documento.idEstado = EstadoDocumentoItem.OBSERVADO;
        }
        else {
          documento.idEstado = EstadoDocumentoItem.PENDIENTE;
        }

        documentosTecnicosModel.documentos.push(documento);
      });

      this.solicitudDocumentoTecnicoService.validar(documentosTecnicosModel).subscribe((data) => {

        if (pendientes == 0) {
          if (pendientesObservados > 0)
            this.alertDialogService.open('Se registró su observación y se notificó al contratista');
          else
            this.alertDialogService.open('Se registró su aprobación');
          this.alertDialogService.closed().subscribe((confirmed) => {
            this.getSolicitud();
          });
        }
        else
          this.getSolicitud();
      });
    }
  }

  openDialogTipoDocumento(idSeccion: SolicitudSeccion): void {
    let tipoDocumento = new AdjuntarTipoDocumentoModel();
    tipoDocumento.idSeccion = idSeccion;


    tipoDocumento.idTipoVisita = this.itemSolicitud.idTipoVisita;
    let continuaRegistro: boolean = false;
    switch (idSeccion) {
      case SolicitudSeccion.Personal: {
        if (this.selectionPersonas.hasValue()) {
          continuaRegistro = true;
          tipoDocumento.listaTipoDocumentos = this.itemSolicitud.lista_documentos_personal;
        }
        else
          this.alertDialogService.open('Seleccione las personas a las que se añadirá el documento');
        break;
      }
      case SolicitudSeccion.Equipos: {
        if (this.selectionEquipos.hasValue()) {
          continuaRegistro = true;
          tipoDocumento.listaTipoDocumentos = this.itemSolicitud.lista_documentos_equipos;
        }
        else
          this.alertDialogService.open('Seleccione los equipos a los que se añadirá el documento');
        break;
      }
      case SolicitudSeccion.Vehiculos: {
        if (this.selectionVehiculos.hasValue()) {
          continuaRegistro = true;
          tipoDocumento.listaTipoDocumentos = this.itemSolicitud.lista_documentos_vehiculos;
        }
        else
          this.alertDialogService.open('Seleccione los vehículos a los que se añadira el documento');
        break;
      }
      case SolicitudSeccion.DocumentacionTecnica: {
        continuaRegistro = true;
        tipoDocumento.listaTipoDocumentos = this.itemSolicitud.documentosTecnicos.map((item) => {
          let documento = new DocumentacionRequeridaModel();
          documento.idConfiguracionDocumento = item.idConfiguracionDocumento;
          documento.documento = item.documento;
          documento.esPredeterminado = item.esPredeterminado;
          documento.idRequisito = item.idRequisito;
          documento.controlarFechas = item.controlarFechas;
          documento.esRequisitoBloqueado =
            documento.idRequisito === DocumentoTipoRequisito.TODOS;

          return documento;
        });
        break;
      }
    }
    if (continuaRegistro) {
      // console.log(tipoDocumento);
      const dialogRef = this.dialog.open(AdjuntarTipoDocumentoDialogComponent, {
        width: '500px',
        data: tipoDocumento,
      });
      dialogRef.afterClosed().subscribe((result: AdjuntarTipoDocumentoModel) => {
        // this.animal = result;
        if (result) {
          let documento: DocumentacionRequeridaModel =
            new DocumentacionRequeridaModel();

          documento.idConfiguracionDocumento = result.idConfiguracionDocumento;
          documento.idMaestroDocumento = result.idMaestroDocumento;
          documento.documento = result.documento;
          documento.esPredeterminado = false;
          documento.idRequisito = result.idRequisito;
          documento.seccion = idSeccion;
          documento.controlarFechas = result.controlarFechas;
          documento.esRequisitoBloqueado =
            result.idRequisito === DocumentoTipoRequisito.TODOS;

          // console.log(documento.esRequisitoBloqueado);
          switch (idSeccion) {
            case SolicitudSeccion.Personal: {

              let modelAsignar = new SolicitudPersonalAsignarDocumentoModel();
              modelAsignar.personas = this.selectionPersonas.selected;
              modelAsignar.documento = documento;

              this.solicitudPersonaService.asignardocumento(this.itemSolicitud.idSolicitud, modelAsignar).subscribe((result: ActionResultModel) => {
                this.getSolicitud();

              });
              break;
            }
            case SolicitudSeccion.Equipos: {
              let modelEquiposAsignar = new SolicitudEquipoAsignarDocumentoModel();
              modelEquiposAsignar.equipos = this.selectionEquipos.selected;
              modelEquiposAsignar.documento = documento;

              this.solicitudEquipoService.asignardocumento(this.itemSolicitud.idSolicitud, modelEquiposAsignar).subscribe((result: ActionResultModel) => {
                this.getSolicitud();

              });
              break;
            }
            case SolicitudSeccion.Vehiculos: {
              let modelVehiculosAsignar = new SolicitudVehiculoAsignarDocumentoModel();
              modelVehiculosAsignar.vehiculos = this.selectionVehiculos.selected;
              modelVehiculosAsignar.documento = documento;

              this.solicitudVehiculoService.asignardocumento(this.itemSolicitud.idSolicitud, modelVehiculosAsignar).subscribe((result: ActionResultModel) => {
                this.getSolicitud();

              });
              break;
            }
            case SolicitudSeccion.DocumentacionTecnica: {
              let modelDocumentosAsignar = new SolicitudDocumentoTecnicoAsignarModel();
              modelDocumentosAsignar.documento = documento;

              this.solicitudDocumentoTecnicoService.asignardocumento(this.itemSolicitud.idSolicitud, modelDocumentosAsignar).subscribe((result: ActionResultModel) => {
                this.getSolicitud();

              });
              break;
            }
          }
        }
      });
    }


  }

  getConfiguracionDocumentosPorTipoVisita() {
    const filterConfiguracionDocumentos: IFilterConfiguracionDocumentoModel =
      new FilterConfiguracionDocumentoModel();

    filterConfiguracionDocumentos.idTipoVisita = this.itemSolicitud.idTipoVisita;

    this.configuracionDocumentoService
      .getList(filterConfiguracionDocumentos)
      .subscribe((data: DocumentacionRequeridaModel[]) => {
        // console.log(data);
        data.forEach((p) => {
          p.esRequisitoBloqueado =
            p.idRequisito === DocumentoTipoRequisito.TODOS;
        });

        this.itemSolicitud.lista_documentos_personal = data.filter(
          (p) => p.seccion == SolicitudSeccion.Personal && p.esPredeterminado
        );
        this.itemSolicitud.lista_documentos_equipos = data.filter(
          (p) => p.seccion == SolicitudSeccion.Equipos && p.esPredeterminado
        );
        this.itemSolicitud.lista_documentos_vehiculos = data.filter(
          (p) => p.seccion == SolicitudSeccion.Vehiculos && p.esPredeterminado
        );

        this.lista_DocumentoTecnicos = data
          .filter(
            (p) =>
              p.seccion == SolicitudSeccion.DocumentacionTecnica &&
              p.esPredeterminado
          )
          .map((item) => {
            let documento = new SolicitudDocumentoTecnicoModel();
            documento.idConfiguracionDocumento = item.idConfiguracionDocumento;
            documento.idMaestroDocumento = item.idMaestroDocumento;
            documento.documento = item.documento;
            documento.esPredeterminado = item.esPredeterminado;
            documento.idRequisito = item.idRequisito;
            // documento2.seccion = idSeccion;
            documento.controlarFechas = item.controlarFechas;
            documento.esRequisitoBloqueado =
              documento.idRequisito === DocumentoTipoRequisito.TODOS;

            return documento;
          });
      });
  }

  deletePersona(element: PersonalModel): void {
    this.confirmDialogService.open(`¿Está seguro de eliminar de la solicitud a ${element.nombres} ${element.apellidoPaterno} ${element.apellidoMaterno}?`); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.solicitudPersonaService.eliminar(element.idSolicitudPersona).subscribe((result) => {
          this.getSolicitud();
          if (result.type != eTypeResult.SUCCESS) {
            this.alertDialogService.open(result.message);
          }
        });
      }
    });
  }

  deleteEquipo(element: EquipoModel): void {
    this.confirmDialogService.open(`¿Está seguro de eliminar de la solicitud el equipo: ${element.equipo}?`); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.solicitudEquipoService.eliminar(element.idSolicitudEquipo).subscribe((result) => {
          this.getSolicitud();
          if (result.type != eTypeResult.SUCCESS) {
            this.alertDialogService.open(result.message);
          }
        });
      }
    });
  }

  deleteVehiculo(element: VehiculoModel): void {
    this.confirmDialogService.open(`¿Está seguro de eliminar de la solicitud el vehículo: ${element.marca}-${element.modelo}?`); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.solicitudVehiculoService.eliminar(element.idSolicitudVehiculo).subscribe((result) => {
          this.getSolicitud();
          if (result.type != eTypeResult.SUCCESS) {
            this.alertDialogService.open(result.message);
          }
        });
      }
    });
  }

  deleteDocTecnico(element: SolicitudDocumentoTecnicoModel): void {
    this.confirmDialogService.open(`¿Está seguro de eliminar de la solicitud el archivo del documento: ${element.documento}?`); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.solicitudDocumentoTecnicoService.eliminar(element.idSolicitudDocumentoTecnico).subscribe((result) => {
          this.getSolicitud();
          if (result.type != eTypeResult.SUCCESS) {
            this.alertDialogService.open(result.message);
          }
        });
      }
    });
  }
}
